import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import SideDrawer from '../Drawer';

const drawerWidth = 300;

const Main = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: `${drawerWidth}px`,
  }),
}));

const isMobile = window.innerWidth <= 768;

/** Membership Hub chrome: SideDrawer + content margin. */
const HubLayout: React.FC = () => {
  const [open, setOpen] = useState(true);
  const handleUpdateDrawer = () => setOpen(!open);

  return (
    <Grid sx={{ position: 'relative' }}>
      <SideDrawer
        open={open}
        isMobile={isMobile}
        handleUpdateDrawer={handleUpdateDrawer}
        drawerWidth={drawerWidth}
      />
      {isMobile ? (
        <Grid item xs={12}>
          <Outlet />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Main open={open}>
            <Outlet />
          </Main>
        </Grid>
      )}
    </Grid>
  );
};

export default HubLayout;
